var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navigation"},[_c('ul',_vm._l((_vm.items),function(item,index){return _c('li',{key:index,staticClass:"navigation-item"},[_c('a',{class:{
          'is-active': _vm.isActive(item.route)
        },attrs:{"href":_vm.route(item.route),"title":item.name}},[_vm._v("\n        "+_vm._s(item.name)+"\n      ")])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }